var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { Events, TrackingActions, useAppDispatch } from 'conversional-journey';
import { getItem, setItem } from 'conversional-persistent-storage';
import { publish } from 'conversional-callbacks';
import TrustPulseComponent from './TrustPulseComponent';
import { renderClasses } from './TrustPulse.styles';
var TRUST_PULSE_STARTED = 'TrustPulse.started';
var TRUST_PULSE_COMPLETED = 'TrustPulse.completed';
var TRUST_PULSE_CLICKED = 'TrustPulse.clicked';
var TRUST_PULSE_FLAG = 'hideTrustPulse';
var TIME_TO_LIVE = 86400000;
export var TrustPulseContainer = function (_a) {
    var animation = _a.animation, _b = _a.componentKey, componentKey = _b === void 0 ? '(not set)' : _b, pulses = _a.pulses, theme = _a.theme;
    var styles = renderClasses(theme);
    var _c = useState({ main: -1, temp: -1 }), counter = _c[0], setCounter = _c[1];
    var timer = useRef(null);
    var dispatch = useAppDispatch();
    var trackEvent = function (event) { return dispatch(TrackingActions.event(event)); };
    function cancelLoop() {
        clearInterval(timer.current);
        publish(TRUST_PULSE_COMPLETED, null, componentKey);
    }
    var onComplete = function () {
        trackEvent(__assign(__assign({}, Events.TRUSTPULSE_COMPLETED), { label: componentKey }));
        cancelLoop();
    };
    var hide = function () {
        trackEvent(__assign(__assign({}, Events.TRUSTPULSE_HIDE), { label: componentKey }));
        cancelLoop();
    };
    var animationHandler = function () {
        setTimeout(function () {
            publish(TRUST_PULSE_STARTED, null, componentKey);
            trackEvent(__assign(__assign({}, Events.TRUSTPULSE_SHOW), { label: componentKey }));
            setCounter(function (oldCounter) {
                if (oldCounter.temp + 1 >= pulses.length) {
                    return {};
                }
                else {
                    return {
                        main: oldCounter.temp + 1,
                        temp: -1
                    };
                }
            });
        }, animation.delayTime * 1000);
        setCounter(function (oldCounter) { return ({ main: -1, temp: oldCounter.main }); });
    };
    useEffect(function () {
        if (typeof counter.main !== 'number' || counter.temp + 1 >= pulses.length) {
            onComplete();
        }
        else {
            timer.current = setInterval(animationHandler, animation.displayTime * 1000);
        }
        return function () {
            clearInterval(timer.current);
        };
    }, [counter && counter.main]);
    useEffect(function () {
        var hideTrustPulse = getItem(TRUST_PULSE_FLAG);
        hideTrustPulse ? cancelLoop() : animationHandler();
        var date = new Date().getTime();
        setItem(TRUST_PULSE_FLAG, date.toString(), { ttl: TIME_TO_LIVE });
        return function () {
            cancelLoop();
        };
    }, []);
    var currentItem = counter.main === -1 ? pulses[counter.temp] : pulses[counter.main];
    var currentItemId = currentItem ? currentItem.id : 0;
    var click = function () {
        publish(TRUST_PULSE_CLICKED, null, componentKey);
        trackEvent(__assign(__assign({}, Events.TRUSTPULSE_CLICKED), { label: componentKey }));
        setItem(TRUST_PULSE_FLAG, new Date().getTime().toString(), { ttl: TIME_TO_LIVE });
    };
    return (_jsx("section", { className: styles.container, children: pulses.map(function (pulse, index) { return (_jsx(TrustPulseComponent, { id: pulse.id, display: { isActive: index === counter.main, currentItem: currentItemId }, headline: pulse.headline, image: pulse.image, message: pulse.message, time: pulse.time, close: hide, onClick: click }, pulse.id || "trust-pulse-".concat(index))); }) }));
};
export default (TrustPulseContainer);
